import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { WINDOW } from './windows.service';
import { KeycloakService } from 'keycloak-angular';

// Menu
export interface Menu {
  path?: string;
  title?: string;
  icon?: string;
  type?: string;
  badgeType?: string;
  badgeValue?: string;
  active?: boolean;
  bookmark?: boolean;
  children?: Menu[];
  queryParams?: any;
}

@Injectable({ providedIn: 'root' })
export class NavService {

  public screenWidth: any;
  public collapseSidebar = false;
  public menuItemsSubject = new BehaviorSubject<Menu[]>([]);

  constructor(
    @Inject(WINDOW) private window,
    private keycloakService: KeycloakService
  ) {
    this.onResize();
    if (this.screenWidth < 991) {
      this.collapseSidebar = true;
    }
  }

  // Windows width
  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }

  MENUITEMS: Menu[] = [
    {
      title: 'Comparator Oferte Energie Electrica', path: '/utilizator/comparator',
      icon: 'home', type: 'link', active: false, queryParams: { comparatorType: "electric" }
    },
    {
      title: 'Comparator Oferte Gaze Naturale', path: '/utilizator/comparator',
      icon: 'home', type: 'link', active: false, queryParams: { comparatorType: "gas" }
    },
    // {
    //   title: 'Comparator Oferte Energie Electrica', path: 'https://anre.ro/comparator-energie-electrica/',
    //   icon: 'home', type: 'extTabLink', active: false
    // },
    // {
    //   title: 'Comparator Oferte Gaze Naturale', path: 'https://anre.ro/comparator-gaze-naturale/',
    //   icon: 'home', type: 'extTabLink', active: false
    // },
    {
      title: 'Persoana fizica', icon: 'user', type: 'sub', active: false, children: [
        { path: '/utilizator/persoana-fizica/date-identificare', title: 'Date identificare', type: 'link' },
        { path: '/utilizator/persoana-fizica/energie-electrica', title: 'Energie electrica', type: 'link' },
        { path: '/utilizator/persoana-fizica/gaze-naturale', title: 'Gaze naturale', type: 'link' },
        { path: '/utilizator/persoana-fizica/notificari', title: 'Notificari', type: 'link' },
      ]
    },
    {
      title: 'Persoana juridica', icon: 'book', type: 'sub', active: false, children: [
        { path: '/utilizator/persoana-juridica/lista-companii', title: 'Date identificare', type: 'link' },
        { path: '/utilizator/persoana-juridica/energie-electrica', title: 'Energie electrica', type: 'link' },
        { path: '/utilizator/persoana-juridica/gaze-naturale', title: 'Gaze naturale', type: 'link' },
      ]
    }
  ];
  MENUITEMSOPERATOR: Menu[] = [
    { path: '/operator/date-identificare', title: 'Date identificare', type: 'link', icon: 'user' },
    { path: '/operator/notificari', title: 'Notificari', type: 'link', icon: 'bell' },
    { path: '/operator/task-uri', title: 'Task-uri', type: 'link', icon: 'list' },
    { path: '/operator/energie-electrica', title: 'Energie Electrica', type: 'link', icon: 'zap' },
    { path: '/operator/gaze-naturale', title: 'Gaze Naturale', type: 'link', icon: 'home' }
  ];
  MENUITEMSSUPPLIER: Menu[] = [
    { path: '/furnizor/date-identificare', title: 'Date identificare', type: 'link', icon: 'user' },
    { path: '/furnizor/notificari', title: 'Notificari', type: 'link', icon: 'bell' },
    { path: '/furnizor/task-uri', title: 'Task-uri', type: 'link', icon: 'list' },
    { path: '/furnizor/energie-electrica', title: 'Energie Electrica', type: 'link', icon: 'zap' },
    { path: '/furnizor/gaze-naturale', title: 'Gaze Naturale', type: 'link', icon: 'home' }
  ];
  MENUITEMSANRE: Menu[] = [
    { path: '/anre/task-uri', title: 'Task-uri', type: 'link', icon: 'list' },
    { path: '/anre/notificari', title: 'Notificari', type: 'link', icon: 'bell' },
    { path: '/anre/furnizori', title: 'Furnizori', type: 'link', icon: 'repeat' },
    { path: '/anre/operatori', title: 'Operatori', type: 'link', icon: 'repeat' },
    { path: '/anre/mesaje', title: 'Mesaje', type: 'link', icon: 'bell' }
  ];

  updateMenuItems(): void {
    const userRoles = this.keycloakService.getUserRoles();
    let menuItems: Menu[] = [];

    if (userRoles.indexOf('final_client') > -1) {
      menuItems = this.MENUITEMS;
    }
    if (userRoles.indexOf('operator') > -1) {
      if (JSON.parse(localStorage.getItem('validatedAndAdminRoleAssigned')) === true) {
        menuItems = this.MENUITEMSOPERATOR;
        if ((JSON.parse(localStorage.getItem('licentaElectricitate')) === false)) {
          menuItems = menuItems.filter(m => !m.path.includes('electrica'));
        }
        if ((JSON.parse(localStorage.getItem('licentaGaz')) === false)) {
          menuItems = menuItems.filter(m => !m.path.includes('gaze'));
        }
      } else {
        menuItems = this.MENUITEMSOPERATOR.slice(0, 2);
      }
    }
    if (userRoles.indexOf('supplier') > -1) {
      if (JSON.parse(localStorage.getItem('validatedAndAdminRoleAssigned')) === true) {
        menuItems = this.MENUITEMSSUPPLIER;
        if ((JSON.parse(localStorage.getItem('licentaElectricitate')) === false)) {
          menuItems = menuItems.filter(m => !m.path.includes('electrica'));
        }
        if ((JSON.parse(localStorage.getItem('licentaGaz')) === false)) {
          menuItems = menuItems.filter(m => !m.path.includes('gaze'));
        }
      } else {
        menuItems = this.MENUITEMSSUPPLIER.slice(0, 2);
      }
    }
    if (userRoles.indexOf('anre') > -1) {
      menuItems = this.MENUITEMSANRE;
    }

    this.menuItemsSubject.next(menuItems);
  }

  /*getItems(): BehaviorSubject<Menu[]> {
    const userRoles = this.keycloakService.getUserRoles();

    if (userRoles.indexOf('operator') > -1) {
      if (JSON.parse(localStorage.getItem('validatedAndAdminRoleAssigned')) === true) {
        let menuItems = this.MENUITEMSOPERATOR;
        if ((JSON.parse(localStorage.getItem('licentaElectricitate')) === false))
        {
          menuItems =menuItems.filter(m => !m.path.includes('electrica'));
        }
        if ((JSON.parse(localStorage.getItem('licentaGaz')) === false))
        {
          menuItems =menuItems.filter(m => !m.path.includes('gaze'));
        }
        return new BehaviorSubject<Menu[]>(menuItems);
      } else {
        return new BehaviorSubject<Menu[]>(this.MENUITEMSOPERATOR.slice(0, 2));
      }
    }
    if (userRoles.indexOf('supplier') > -1) {
      if (JSON.parse(localStorage.getItem('validatedAndAdminRoleAssigned')) === true) {
        let menuItems = this.MENUITEMSSUPPLIER;
        if ((JSON.parse(localStorage.getItem('licentaElectricitate')) === false))
        {
          menuItems =menuItems.filter(m => !m.path.includes('electrica'));
        }
        if ((JSON.parse(localStorage.getItem('licentaGaz')) === false))
        {
          menuItems =menuItems.filter(m => !m.path.includes('gaze'));
        }
        return new BehaviorSubject<Menu[]>(menuItems);
      } else {
        return new BehaviorSubject<Menu[]>(this.MENUITEMSSUPPLIER.slice(0, 2));
      }
    }
    if (userRoles.indexOf('anre') > -1) {
      return new BehaviorSubject<Menu[]>(this.MENUITEMSANRE);
    }
    return new BehaviorSubject<Menu[]>(this.MENUITEMS);
  }*/
}
